export default __webpack_public_path__ + "static/N0123-0dc6ea03b953e958c4a606c1d3396ecb.png";